module.exports = __webpack_public_path__ + "img/SiteInfo.23689a42.svg";